const CciEventTrackingPlugin = {
  install (Vue, options) {
    this.Vue = Vue
    Vue.prototype.cciEventTracking = Vue.cciEventTracking = []
    if (options && options.eventTrackingModule) {
      this.setEventTrackingModule(options.eventTrackingModule)
    }
    Vue.prototype.$cciEventTrackingPlugin = Vue.cciEventTrackingPlugin = this
  },
  trackEvent (...args) {
    if (!this.Vue.cciEventTracking) return
    for (var i = 0; i < this.Vue.cciEventTracking.length; i++) {
      this.Vue.cciEventTracking[i].trackEvent(...args)
    }
  },
  setEventTrackingModule (cciEventTracking) {
    cciEventTracking.init()
    this.Vue.prototype.$cciEventTracking = this.Vue.cciEventTracking.push(cciEventTracking)
  }
}

export default CciEventTrackingPlugin
